import makeStyles from '@mui/styles/makeStyles';

export const useClinicianStyles = makeStyles((theme) => ({
    colorSystem: {
        width: 16,
        height: 16,
        backgroundColor: 'white',
        display: 'inline-block',
        marginRight: 10,
        verticalAlign: 'middle',
        border: '1px solid #222',
    }, colorSystemTextBox: {
        width: 16,
        height: 16,
        backgroundColor: 'white',
        display: 'inline-block',
        marginRight: 5,
        marginLeft: 5,
        verticalAlign: 'middle',
        border: '1px solid #222',
    }, discriminator: {
        display: 'inline-block', verticalAlign: 'middle',
    }, error: {
        color: '#f44336',
    }, input: {
        width: '100%', fontSize: '15px', marginBottom: 10, borderRadius: '6%',
    }, noteField: {
        marginTop: '15px',
        width: '100%',
    }, agyleButton: {
        backgroundColor: '#448FFF',
    }, checkBtn: {
        width: '35%', maxWidth: '135px', height: '37px', background: '#C33131', // display: "inline-block",
        display: 'flex', justifyContent: 'center', alignItems: 'center', // textAlign: "center",
        lineHeight: '35px', fontSize: '0.9em',

    }, checked: {
        background: '#69BB69', textAlign: 'center', padding: '10px 20px', maxWidth: '135px', width: '35%',
    }, historyLabel: {
        '& .label-part1': {
            fontWeight: 'bold',
        }, '& .label-part2': {
            fontWeight: 'normal', margin: '0 10px', wordBreak: 'break-word',
        }, '& .label-part3': {
            fontSize: '90%', opacity: .7, whiteSpace: 'break-spaces',
        },
    }, noteItem: {
        width: '100%', maxWidth: '357px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
        maxHeight: '51px', display: 'flex', alignItems: 'center', paddingLeft: '5px',
    }, indexNumber: {
        display: 'inline-block', backgroundColor: theme.palette.mode === 'light' ? '#9a9593' : 'white', color: 'black',
        fontWeight: 'bold', padding: '5px 10px', borderRadius: '5px', marginRight: '10px', width: '34px',
        height: '34px', textAlign: 'center',
    }, noteText: {
        display: 'inline-block', border: '1px solid #626466', padding: '5px 10px', borderRadius: '10px',
        minWidth: '100px', width: '100%', maxWidth: '290px', overflow: 'hidden',
    }, listItem: {
        display: 'flex',
    }, checkedBy: {
        fontSize: '8px', marginBottom: '-20px', '&.mobile': {
            fontSize: '6px',
        },
    }, checkedByTimestampText: {
        fontSize: '8px', '&.mobile': {
            fontSize: '6px',
        },
    }, notCompletedTimestampText: {
        fontSize: '12px', '&.mobile': {
            fontSize: '6px',
        },
    },
}));